module.exports = __webpack_public_path__ + "public/SideMenuIcons/analytics.svg?503b9a24";